import { Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Information} from './information';
import {Router} from '@angular/router';

@Component({
    templateUrl: './information.component.html',
    styleUrls: ['./information.component.scss'],
    standalone: false
})
export class InformationComponent {
  private router = inject(Router);
  information = inject<Information>(MAT_DIALOG_DATA);

  navigateToUrl(url: string) {
    this.router.navigateByUrl(url)
  }
}
